import React from 'react';
import {GameJackpotBox} from "./boxes/root/game-jackpot.box";
import {GameJackpotValueBox} from "./boxes/value/game-jackpot-value.box";
import {CyClass} from "../../../common/cy-classes";
import {observer} from "mobx-react";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {useServices} from "../../react-hooks/use-services.hook";
import {withServices} from "../../react-hooks/with-services";


export interface GameJackpotComponentProps extends ComponentServicesPick<'jackpots'> {
  gameType: number;
  className?: string;
}

const ComponentBody: React.FC<GameJackpotComponentProps> = observer((props) => {
    const services = useServices();
    const jackpotValue = props.jackpots.getGameJackpots(props.gameType)?.currentAmountInCents;
    if(!jackpotValue) {
        return null;
    }

    return (

        <GameJackpotBox className={props.className}>
            <GameJackpotValueBox className={CyClass('cy-game-jackpot-amount')}>
                {services.currency.formatMoney(jackpotValue)}
            </GameJackpotValueBox>
        </GameJackpotBox>
    );
})

export const GameJackpotComponent = withServices(ComponentBody, ['jackpots']);